<template>
    <div ref="container">
        <slot />
    </div>
</template>

<script>
const OFFSET = (window.innerHeight / 900) * 500 + (window.innerHeight - 900) / 2; // The offset relative to the bottom
const MINIMUM_SCROLL = 0; // The scroll-difference needed to trigger a pagination

export default {
    name: 'Pagination',
    data: () => ({
        scrollableContainer: null, // The container that is getting scrolled
        currentAnchor: 0, // The scroll value of the previous paginate-hit
    }),
    methods: {
        onscroll() {
            const container = this.$refs.container;
            const currentScrollValue = this.getScrollTop();
            const documentHeight = this.getDocumentHeight();
            const diff = documentHeight - OFFSET - currentScrollValue;

            // Check if difference should trigger a pagination
            if (diff < 0 && this.currentAnchor - currentScrollValue < -MINIMUM_SCROLL) {
                this.$emit('onBottom');
                this.currentAnchor = currentScrollValue;
            }
        },
        getScrollTop() {
            const scrollTop =
                document.documentElement && document.documentElement.scrollTop
                    ? document.documentElement.scrollTop
                    : 0;
            const clientTop =
                document.documentElement && document.documentElement.clientTop
                    ? document.documentElement.clientTop
                    : 0;
            return (window.pageYOffset || scrollTop) - (clientTop || 0) || 0;
        },
        getDocumentHeight() {
            return this.$refs.container.clientHeight - this.$refs.container.offsetTop;
        },
        resetCurrentAnchor() {
            this.currentAnchor = 0;
        },
    },
    created() {
        this.scrollableContainer = window;
        this.scrollableContainer.addEventListener('scroll', this.onscroll);
    },
    destroyed() {
        this.scrollableContainer.removeEventListener('scroll', this.onscroll);
    },
};
</script>

<style scoped></style>
